import { render, staticRenderFns } from "./myNew.vue?vue&type=template&id=0a3b919a&scoped=true"
import script from "./myNew.vue?vue&type=script&lang=js"
export * from "./myNew.vue?vue&type=script&lang=js"
import style0 from "./myNew.vue?vue&type=style&index=0&id=0a3b919a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3b919a",
  null
  
)

export default component.exports